import store from '../store';
import Constants from '../config/constants';
import {
    serviceGetIdCardList,
} from "../services/IdCard.service";

export const FETCH_INIT = 'FETCH_INIT_ID_CARD';
export const FETCHED = 'FETCHED_ID_CARD';
export const FETCHED_FAIL = 'FETCHED_FAIL_ID_CARD';
export const FETCHED_FILTER = 'FETCHED_FILTER_ID_CARD';
export const FETCH_NEXT = 'FETCH_NEXT_ID_CARD';
export const FILTER = 'FILTER_ID_CARD';
export const RESET_FILTER = 'RESET_FILTER_ID_CARD';
export const SET_SORTING = 'SET_SORTING_ID_CARD';
export const SET_FILTER = 'SET_FILTER_ID_CARD';
export const SET_PAGE = 'SET_PAGE_ID_CARD';
export const CHANGE_PAGE = 'CHANGE_PAGE_ID_CARD';
export const CHANGE_STATUS= 'CHANGE_STATE_ID_CARD';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_ID_CARD';

export function actionFetchIdCard(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetIdCardList({ index, row: sorting.row , order: sorting.order, ...filter }); // GetIdCard
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionChangePageIdCard(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterIdCard(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});
        });
    };
}


export function actionChangeStatusIDCard(id, status) {
    //const request = serviceUpdateIDCard({ id: params.id, status: params.type});
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterIDCard() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionSetPageIDCard(page) {
    const stateData = store.getState().id_card;
    const currentPage = stateData?.currentPage;
    const totalLength = stateData?.all.length;
    const sortingData = stateData?.sorting_data;
    const query = stateData?.query;
    const queryData = stateData?.query_data;
    const startDate = stateData?.start_date;
    const endDate = stateData?.end_date;
    const serverPage = stateData?.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchIdCard(serverPage + 1, sortingData, {query, query_data: queryData, start_date: startDate, end_date: endDate}));
    }

    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}
